import React, { useEffect, useState } from 'react';

const StatusCircle = () => {
  const [online, setOnline] = useState(navigator.onLine);

  useEffect(() => {
    const goOnline = () => setOnline(true);
    const goOffline = () => setOnline(false);
    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);
    return () => {
      window.removeEventListener('online', goOnline);
      window.removeEventListener('offline', goOffline);
    };
  }, []);

  return (
    <span
      title={online ? 'Online' : 'Offline'}
      className={`ml-2 w-3 h-3 rounded-full shadow ${
        online
          ? 'bg-green-500 animate-pulse shadow-green-400/60'
          : 'bg-red-500'
      }`}
      style={{ display: 'inline-block', border: '2px solid var(--c-surface)' }}
    />
  );
};

export default StatusCircle;